var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-separator",class:( _obj = {'with-border border-b border-gray-200': _vm.hasBorder, 'mt-0': _vm.noMarginTop}, _obj[("size-" + _vm.size)] = _vm.size, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }